/**
 * Release switches: work that is built and tested but not yet offered to players.
 *
 * Flipping one is a product decision, the owner's, and nothing else: it is a one-line
 * change here, in its own commit. The code behind a switch stays in the build and in the
 * tests, so it keeps working while it waits.
 *
 * A switch is UX, never access control (CLAUDE.md §10): anything a player could unlock
 * by flipping it in their own browser must also be refused by the server.
 */
export const RELEASES = {
  /**
   * The supporter pack (D-044): the premium themes and the purchase that unlocks them.
   * Owner, 2026-09-27 (D-047): not at launch. Until it is released, only the two launch
   * themes are offered, and the terms say nothing about buying anything.
   */
  supporterPack: false,
} as const;
